import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@app/api/auth/auth.service';

export const ForceChangePasswordGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const organizacao =
    route.params['organizacao'] ||
    route.parent?.params?.['organizacao'] ||
    state.url.split('/')[1] ||
    '';

  if (!authService.isLogged) {
    return router.createUrlTree([`/${organizacao}/auth/sign-in`], {
      queryParams: { returnUrl: state.url },
    });
  }

  const isForceChangeRoute = state.url.includes('/auth/force-change-password');

  if (authService.mustChangePassword && !isForceChangeRoute) {
    return router.createUrlTree([`/${organizacao}/auth/force-change-password`], {
      queryParams: { returnUrl: state.url },
    });
  }

  if (!authService.mustChangePassword && isForceChangeRoute) {
    return router.createUrlTree([`/${organizacao}/dashboard`]);
  }

  return true;
};
